interface IOptions {
  verbose: boolean;
}

class Logger {
  private verbose = false;

  log(...args: any[]) {
    if (window.console && this.verbose) {
      window.console.log(...args);
    }
  }

  setOptions({ verbose }: IOptions) {
    this.verbose = verbose;
  }
}

export default new Logger();
